import React, { useEffect, useState } from "react";
import {
  English,
  en_AlertMsg,
  en_ButtonText,
  en_visits,
} from "../Languages/en";
import {
  Box,
  Button,
  FormLabel,
  Grid,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import MuiDate from "../component/shared/MUIDatePicker";
import dayjs from "dayjs";
import { format, isValid } from "date-fns/esm";
import VisitNavbar from "../component/VisitNavbar";
import Header from "../component/Header";
import { useNavigate } from "react-router-dom";
import { URL, colors } from "../utils/constant";
import useVisitDetails from "../data/talons/Visits/useVisit";
import { useAuth } from "../data/talons/auth/useAuth";

// import TextField from "@mui/material/TextField";
// import Typography from "@mui/material/Typography";
import { getVisitsData } from "../data/selector/visits.selector";
import { useDispatch, useSelector } from "react-redux";
import {
  setSelectedDate,
  setSelectedVisit,
  setSelectedVist,
  setVisitDate,
  setVisitRange,
} from "../data/reducer/visits.reducer";
import GlobalPageLoader from "../data/talons/loader/useFullPageLoader";

import Dialogue from "../component/shared/Dialogue";
import {
  getLanguage,
  getLanguageNumber,
} from "../data/selector/language.selector";
import { getUserToken } from "../data/selector/appState.selector";
import {
  selectedVisitDate,
  setBloodSugarComponent,
  setPageId,
  setSelectedRecordDate,
} from "../data/reducer/component.reducer";
import {
  getBloodSugarUpdate,
  getCalculateDate,
  getPageStatusData,
  getRecordDate,
} from "../data/selector/component.selector";
import { Spanish } from "../Languages/sp";
import { setSelectedLanguage } from "../data/reducer/language.reducer";
import { get, isEqual, size } from "lodash";
import { isAfter, isBefore, parse } from "date-fns";

const Visits = () => {
  const { visits, fetchVisitDetails } = useVisitDetails();
  // const { autoLogout } = useAuth();
  // const { inactivityTimeout, handleMouseMove, isActive } = autoLogout();
  // const [startDateApply, setStartDateApply] = useState(new Date());
  const [open, setOpen] = React.useState(false);
  const Language = useSelector(getLanguage);
  const number = useSelector(getLanguageNumber);
  const [selectedDateVisit, setSelectedDateVisit] = useState(
    format(new Date(), "dd/MMM/yyyy")
  );
  const dateInMs = new Date(selectedDateVisit)?.getTime();
  const [visitRange, setVisitRange] = useState([]);
  const [Alert, setAlert] = useState("");
  // const FormatedStartDate = format(selectedDate, "d MMM,yyyy");
  const navigate = useNavigate();
  const token = useSelector(getUserToken);
  const visitData = useSelector(getVisitsData);
  // console.log(visitData, "visitDatavisitData");
  const dispatch = useDispatch();

  const pageStatusApiData = useSelector(getPageStatusData);
  useEffect(
    () => {
      if (size(token) === 0) {
        navigate(URL.login);
      }

      const pageStatusobj = {
        pageData: pageStatusApiData[0],
      };
      dispatch(setPageId(pageStatusobj));
      dispatch(setBloodSugarComponent({ recordNo: 1 }));

      fetchVisitDetails();
      // autoLogout();
      dispatch(setSelectedDate(null));
    }, // eslint-disable-next-line

    [token]
  );

  useEffect(() => {
    // console.log(dropdownValue, "vkvkvkv");
    if (!number) {
      // console.log("noneWnglish");
      dispatch(setSelectedLanguage(English));
    } else if (number == 1) {
      // console.log("english");
      dispatch(setSelectedLanguage(English));
    } else if (number == 2) {
      // console.log("spanish");
      dispatch(setSelectedLanguage(Spanish));
    }
    // dispatch(setSelectedLanguage(Spanish));
    // console.log("nnnn");
  }, [number]);

  const handleVisitRange = () => {
    const newRange = visitData?.map((item) => ({
      startDate: item?.VisitStartDate,
      endDate: item?.VisitEndDate,
    }));
    setVisitRange(newRange);
  };
  const dateArray = useSelector(getCalculateDate);
  const dateSelector = useSelector(getRecordDate);
  const selectedDateIndex = dateArray?.findIndex(
    (date) => date === dateSelector
  );
  useEffect(() => {
    handleVisitRange();
  }, [visitData]); // Trigger handleVisitRange when visitData changes

  const checkDateRange = (date) => {
    let notStarted = false;
    const currentDate = new Date().getTime(); // Get current date in milliseconds

    const foundVisit = visitData?.find((item) => {
      const startDate = Date.parse(item?.VisitStartDate);
      const endDate = Date.parse(item?.VisitEndDate);
      const currentDate = Date.parse(new Date());

      const isDateInRange = (targetDate, startDate, endDate) => {
        const parsedTargetDate = parse(targetDate, "dd/MMM/yyyy", new Date());
        const parsedStartDate = parse(startDate, "dd/MMM/yyyy", new Date());
        const parsedEndDate = parse(endDate, "dd/MMM/yyyy", new Date());

        return (
          (isAfter(parsedTargetDate, parsedStartDate) ||
            isEqual(parsedTargetDate, parsedStartDate)) &&
          (isBefore(parsedTargetDate, parsedEndDate) ||
            isEqual(parsedTargetDate, parsedEndDate))
        );
      };

      let result = false;

      if (item?.VisitStatus !== "0") {
        result = isDateInRange(date, item?.VisitStartDate, item?.VisitEndDate);
      } else if (
        item?.VisitStatus === "0" &&
        isDateInRange(date, item?.VisitStartDate, item?.VisitEndDate)
      ) {
        result = currentDate >= endDate;
      } else {
        result = false;
      }
      if (result) {
        return true;
      }
    });

    if (foundVisit) {
      dispatch(setSelectedRecordDate(selectedDateVisit));
      dispatch(setSelectedVisit(foundVisit));
      dispatch(selectedVisitDate(selectedDateIndex));
      navigate(URL.savedRecords);
      // Redirect to form page here
    } else if (notStarted) {
      setAlert(Language?.AlertMsg.selectVisitDate);
      setOpen(true);
    } else {
      setAlert(Language?.AlertMsg.selectVisitDate);
      setOpen(true);
    }
  };

  return (
    <>
      {GlobalPageLoader()}
      <VisitNavbar />
      <Header />
      <Dialogue open={open} setOpen={setOpen} Alert={Alert} />
      <Grid sx={{ marginLeft: "4rem", pt: 10, bgcolor: "whitesmoke", pb: 1 }}>
        <Stack
          direction={"row"}
          flex={1}
          spacing={2}
          justifyContent="space-between"
        >
          <Stack>
            <h1 className="ps-4">{Language?.visitsTitle.visits_head}</h1>
          </Stack>
          <Box
            className="d-flex align-items-center gap-3"
            sx={{
              width: "fit-content",
            }}
          >
            <FormLabel className="fw-bold">
              {Language?.visitPageandStatus?.selectDate}
            </FormLabel>
            <MuiDate
              className="bg-light"
              name="date"
              value={selectedDateVisit}
              onChange={(date) => {
                // console.log(date, "nfdkjasndf");
                const formattedDate = dayjs(date.$d).format("DD/MMM/YYYY");
                // console.log(dayjs(date.$d).format("DD/MMM/YYYY"), "fffffff");
                setSelectedDateVisit(formattedDate);
              }} // Handle date change in Visits component
            />

            <Button
              onClick={() => checkDateRange(selectedDateVisit)}
              variant="contained"
              className="fw-bold"
              style={{
                borderRadius: 0,
                backgroundColor: colors.blue,
                color: "white",
                lineHeight: 2.5,
                // width: 100,
                border: "none",
                fontSize: 12,
              }}
            >
              {Language.ButtonText.Add_New_Entry}
            </Button>
          </Box>
          <Stack></Stack>
          {/* </div> */}
        </Stack>
        <Grid
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(4, 1fr)",
            gap: "2rem",
            margin: "2rem",
          }}
        >
          {visitData?.map((item) => {
            let bgColor = "whitesmoke"; // Default background color

            let isPastVisit = false;
            let isActiveVisit = false;
            let isFutureVisit = false;
            const visitStartDate = get(item, "VisitStartDate");
            const visitEndDate = get(item, "VisitEndDate");
            if (size(visitStartDate) >= 0 && size(visitEndDate) >= 0) {
              const currentDate = new Date();
              const startDate = Date.parse(visitStartDate);
              const endDate = Date.parse(visitEndDate);

              let today = new Date();
              today = today.setHours(0, 0, 0, 0);

              const newDate = Date.parse(visitStartDate);
              isPastVisit = endDate < currentDate;

              isActiveVisit = startDate <= today && endDate >= today;

              isFutureVisit = startDate > currentDate;
            }

            if (isActiveVisit) {
              bgColor = colors?.orange;
            } else if (item?.VisitStatus == 2) {
              // isPastVisit
              bgColor = colors?.green;
            } else if (item?.VisitStatus == 1) {
              // isActiveVisit
              bgColor = "#4169E1"; // colors.orange
            } else if (isPastVisit) {
              bgColor = "#636363"; // dark grey
            } else {
              bgColor = colors?.btnDisable;
            }

            const isClickable = bgColor !== colors.btnDisable; // Determine if the item should be clickable
            return (
              <Stack
                sx={{
                  backgroundColor: bgColor,
                  alignItems: "center",
                  display: "flex",
                  justifyContent: "center",
                  padding: 3,
                  cursor: isClickable ? "pointer" : "default", // Change cursor based on clickability
                  opacity: isClickable ? 1 : 0.5, // Reduce opacity if item is not clickable
                }}
                onClick={() => {
                  if (isClickable) {
                    dispatch(setSelectedRecordDate(item?.VisitStartDate));
                    dispatch(setSelectedVisit(item));
                    dispatch(setSelectedDate(item?.VisitStartDate));
                    navigate(URL.savedRecords);
                  }
                }}
                key={item?.VisitId}
                disabled={!isClickable} // Disable the Stack if it's not clickable
              >
                {/* {dispatch(
                    setVisitRange([
                      {
                        startDate: item.VisitStartDate,
                        endDate: item.VisitEndDate,
                      },
                    ])
                  )} */}
                <h3 style={{ color: "white", textAlign: "center" }}>
                  {item?.VisitName}
                </h3>
                <p style={{ color: "white" }}>
                  {Language.visitPageandStatus.startDate} :{" "}
                  {item?.VisitStartDate}
                </p>
                <p style={{ color: "white" }}>
                  {Language.visitPageandStatus.endDate}: {item?.VisitEndDate}
                </p>
              </Stack>
            );
          })}
        </Grid>
        {/* <Grid
          sx={{ mx: 1, border: "1px solid black", p: 1 }}
          display={"flex"}
          alignItems={"center"}
          justifyContent={"space-between"}
        >
          <Typography>{Language.visitsTitle.legend}:</Typography>
          <Typography className="d-flex align-items-center gap-1">
            {" "}
            <Stack
              style={{
                height: "13px",
                width: "13px",
                backgroundColor: colors.grey,
              }}
            ></Stack>
            <Stack>- {Language.visitPageandStatus.notStarted}</Stack>
          </Typography>
          <Typography className="d-flex align-items-center gap-1">
            <Stack
              style={{
                height: "13px",
                width: "13px",
                backgroundColor: colors.orange,
              }}
            ></Stack>
            <Stack>- {Language.visitPageandStatus.active}</Stack>
          </Typography>
          <Typography className="d-flex align-items-center gap-1">
            <Stack
              style={{
                height: "13px",
                width: "13px",
                backgroundColor: colors.blue2,
              }}
            ></Stack>
            <Stack>- {Language.visitPageandStatus.inProgress}</Stack>
          </Typography>
          <Typography className="d-flex align-items-center gap-1">
            <Stack
              style={{
                height: "13px",
                width: "13px",
                backgroundColor: colors.green,
              }}
            ></Stack>
            <Stack>- {Language.visitPageandStatus.Completed}</Stack>
          </Typography>
          <Typography></Typography>
        </Grid> */}
      </Grid>
    </>
  );
};

export default Visits;
